import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router';
import './Styles/index.scss';
import './Styles/App.css';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { QueryProvider } from './_contexts/QueryProvider';
import { AppLoader } from './_components/AppLoader/AppLoader';
import { ErrorBoundary } from './_components/ErrorBoundary';
import { Suspense } from 'react';
import { TimeLoaderFullscreen } from './_components/TimeLoaderFullscreen';
import { AuthContextProvider } from './Authentication/AuthContext';
import { UserActiveCheck } from './components/Contexts/UserActiveCheck';
import { UIContext } from './components/Contexts/UIContext/UIContext';
import { GridContextProvider } from './components/Contexts/GridContext/GridContext';
import { App } from './App';
import { TimeThemeProvider } from './components/Contexts/TimeThemeProvider/TimeThemeProvider';

initializeIcons('/fonts/');

const rootElement = document.getElementById('root');

const CommonSuspenseBoundary = ({ children }: { children: React.ReactNode }) => {
    return <Suspense fallback={<TimeLoaderFullscreen />}>{children}</Suspense>;
};

ReactDOM.render(
    <ErrorBoundary>
        <QueryProvider>
            <UIContext>
                <TimeThemeProvider>
                    <BrowserRouter>
                        <AppLoader>
                            {/* This suspense boundary keeps the suspension from reaching the <AppLoader /> */}
                            <CommonSuspenseBoundary>
                                <AuthContextProvider>
                                    <GridContextProvider>
                                        <UserActiveCheck>
                                            <App />
                                        </UserActiveCheck>
                                    </GridContextProvider>
                                </AuthContextProvider>
                            </CommonSuspenseBoundary>
                        </AppLoader>
                    </BrowserRouter>
                </TimeThemeProvider>
            </UIContext>
        </QueryProvider>
    </ErrorBoundary>,
    rootElement,
);
